import React from "react";
import { Link } from "react-router-dom";
import {
  HiShieldCheck,
  HiOutlineChartBar,
  HiOutlineLightningBolt,
} from "react-icons/hi";
import { BasicInfo } from "../Config/BasicInfo";
import "../Pages/Auth.css";

const AuthLayout = ({
  title,
  subtitle,
  children,
  footerText,
  footerLinkText,
  footerTo,
  onFooterClick,
}) => {
  return (
    <div className="authScreen">
      <div className="authShell">
        <aside className="authBrand">
          <div className="brandTop">
            <img src={BasicInfo.logo} alt="logo" className="brandLogo" />
            <h2 className="brandTitle">
              Your gateway to <span>smarter DeFi</span> earnings.
            </h2>
            <p className="brandText">
              Stake, track and grow your assets with a platform built for
              performance and transparency.
            </p>
          </div>

          <ul className="brandList">
            <li>
              <i>
                <HiShieldCheck />
              </i>
              <div>
                <strong>Bank-grade security</strong>
                <span>Your funds and data stay protected</span>
              </div>
            </li>
            <li>
              <i>
                <HiOutlineChartBar />
              </i>
              <div>
                <strong>Real-time dashboard</strong>
                <span>Track earnings and team growth live</span>
              </div>
            </li>
            <li>
              <i>
                <HiOutlineLightningBolt />
              </i>
              <div>
                <strong>Fast withdrawals</strong>
                <span>Access your rewards anytime, 24/7</span>
              </div>
            </li>
          </ul>

          <p className="brandFoot">
            © {new Date().getFullYear()} {BasicInfo.projectName} — All rights
            reserved
          </p>
        </aside>

        <div className="authPanel">
          <div className="authMobileLogo">
            <img src={BasicInfo.logo} alt="logo" />
          </div>

          <div className="authHead">
            <h1 className="authTitle">{title}</h1>
            <p className="authSubtitle">{subtitle}</p>
          </div>

          {children}

          <div className="authFooter">
            <p>
              {footerText}
              <Link to={footerTo} onClick={onFooterClick}>
                {footerLinkText}
              </Link>
            </p>
            <div className="authSecure">
              <HiShieldCheck />
              <span>Secured with 256-bit encryption</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
